import React from 'react';
import classNames from 'classnames';
import RenderInBody from 'components/shared/render_in_body';
import request from 'utils/request_ajax';
import { Icon, Spinner } from 'ui';
import { routes } from 'constants/config';
import ScormModal from './ScormModal';

class ScormUpdateButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scormId: props.scormId,
      lessonId: props.lessonId,
      loading: false,
      scormData: null,
      scormModalVisible: false,
    };
    this.openModal = this.openModal.bind(this);
    this.loadScormData = this.loadScormData.bind(this);
    this.closeScormModal = this.closeScormModal.bind(this);
    this.handleDataFail = this.handleDataFail.bind(this);
  }

  openModal() {
    if (!this.state.loading) {
      this.setState({ loading: true }, this.loadScormData);
    }
  }

  loadScormData() {
    request
      .get(routes.SCORM_DATA(this.state.scormId))
      .then(scormData => {
        this.setState({
          loading: false,
          scormData,
          scormModalVisible: true,
        });
      })
      .fail(this.handleDataFail);
  }

  handleDataFail() {
    this.setState({
      loading: false,
      scormData: null,
      scormModalVisible: false,
    });
    alert(t('common.server_error')); // eslint-disable-line
  }

  closeScormModal() {
    this.setState({
      loading: false,
      scormData: null,
      scormModalVisible: false,
    });
  }

  render() {
    const buttonClasses = classNames('dropdown-toggle PanelToolbar-link', {
      'PanelToolbar-disabled': this.state.loading,
    });
    const { scormModalVisible, scormData, scormId, lessonId } = this.state;

    return (
      <>
        <div
          onClick={this.openModal}
          onKeyDown={e => e.key === 'Enter' && this.openModal()}
          tabIndex="0"
          role="button"
          className={buttonClasses}
          href="#"
        >
          {this.state.loading && (
            <span className="mr-16 d-b">
              <Spinner className="Icon" />
            </span>
          )}
          {!this.state.loading && <Icon name="edit" />}
          {t('actions.update')}
        </div>
        {scormModalVisible && (
          <RenderInBody>
            <ScormModal
              closeScormModal={this.closeScormModal}
              scormModalVisible={scormModalVisible}
              workspaces={this.props.workspaces}
              hasWorkspaceFeature={this.props.hasWorkspaceFeature}
              hasScormFullWidthFeature={this.props.hasScormFullWidthFeature}
              title={scormData.title}
              description={scormData.description}
              popout={scormData.popout}
              finish={scormData.finish}
              restart={scormData.restart}
              fullWidth={scormData.display_full_width}
              workspaceId={scormData.workspace_id}
              scormId={scormId}
              lessonId={lessonId}
            />
          </RenderInBody>
        )}
      </>
    );
  }
}

export default ScormUpdateButton;
